var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatingLoadStatus1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.508 6.22l-1.44 1.032-.528-.78 2.34-1.68h.648V13h-1.02V6.22zm5.987-1.812h.948L5.879 13H4.93l3.564-8.592zm5.087 6.828H9.645v-.768l3.84-5.676h1.104v5.484h1.056v.96H14.59V13h-1.008v-1.764zm0-.96V6.28h-.049l-2.723 3.996h2.771z",
    fill: "#9390A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#07AFF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 7,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatingLoadStatus1);
export default __webpack_public_path__ + "static/media/creating-load-status-1.614ea2d497c54380276e567e3188b567.svg";
export { ForwardRef as ReactComponent };